import { BarChart3, DollarSign, Calendar } from "lucide-react";
import { toFormattedCurrency } from "utils/currencyUtil";

/** Align with backend `src/project/utils/feature-dependencies.ts`. */
export const BUDGET_SCHEDULE_REQUIRES_SCRIPT_BREAKDOWN_MESSAGE =
  "Script breakdown is required when budgeting or scheduling is enabled.";

/** Keep in sync with backend `IsValidBudgetAmount` (`src/common/utils/custom-vaildators.ts`). */
export const MAX_BUDGET_VALUE = 350000000;
/** Keep in sync with backend `IsValidBudgetAmount` (`src/common/utils/custom-vaildators.ts`). */
export const MIN_BUDGET_VALUE = 35000;
export const INVALID_BUDGET_MESSAGE = `Max Budget should be in the range ${toFormattedCurrency(
  MIN_BUDGET_VALUE
)} - ${toFormattedCurrency(MAX_BUDGET_VALUE)}`;

// Feature groups for accordion
export const featureGroups = [
  {
    id: "analysis",
    title: "Analysis Features",
    icon: BarChart3,
    features: ["Coverage", "Character breakdown", "Script breakdown"],
    description: "AI-powered script analysis and breakdown",
  },
  {
    id: "budget",
    title: "Budget Features",
    icon: DollarSign,
    features: ["Budget"],
    description: "Budget estimation and tracking",
  },
  {
    id: "schedule",
    title: "Schedule Features",
    icon: Calendar,
    features: ["Schedule"],
    description: "Production scheduling and planning",
  },
];

// File upload constants — MIME keys must match real browser/OS declarations (react-dropzone).
// Keep MAX_FILE_SIZE in step with the multipart `fileSize` limit in the backend's main.ts;
// a larger value here just moves the failure deeper into the stack.
export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
export const ACCEPTED_FILE_TYPES = {
  "application/pdf": [".pdf"],
  "application/octet-stream": [".pdf", ".fdx", ".celtx", ".fountain"],
  "text/plain": [".fountain"],
  "application/xml": [".fdx", ".celtx"],
  "text/xml": [".fdx", ".celtx"],
  "application/zip": [".celtx", ".fdx"],
};
